import {makeAutoObservable} from "mobx";
import {ViewController} from "data/types/structure";
import {injectable} from "inversify";
import {isEmpty, isFunction} from "lodash";

interface IProps {
	id: string;
	path: string;
	size: [number, number] | [number, number][];
}

export interface IAdvertController extends ViewController<IProps> {
	init(param: IProps): void;
}

@injectable()
export class AdvertController implements IAdvertController {
	constructor() {
		makeAutoObservable(this);
	}

	init(param: IProps) {
		const GT = window.googletag;

		if (GT && isFunction(GT.pubads)) {
			GT.cmd.push(function () {
				GT.defineSlot(param.path, param.size, param.id)?.addService(GT.pubads());

				GT.pubads().enableAsyncRendering();
				GT.pubads().enableSingleRequest();
				GT.pubads().disableInitialLoad(); // Every page calls googletag.pubads().refresh(), so wait for that before displaying
				GT.enableServices();
				GT.display(param.id);
			});

			if (!isEmpty(GT.pubads()?.getSlots())) {
				GT.pubads().refresh();
			}
		}
	}
}
